import "./App.css";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import PostDetailPage from "./pages/post/PostDetailPage";
import PostPage from "./pages/post/PostPage";
import LandingPage from "./pages/main/LandingPage";
import LoginPage from "./pages/auth/LoginPage";
import { history } from "./core/helpers/history";
import ShellLayout from "./core/layouts/ShellLayout";
import RegisterPage from "./pages/auth/RegisterPage";
import PostEditPage from "./pages/post/PostEditPage";
import PostSearchPage from "./pages/post/PostSearchPage";
import ProfilePage from "./pages/main/ProfilePage";
import EditProfilePage from "./pages/main/EditProfilePage";
import MyPostPage from "./pages/post/MyPostPage";
import UsersPage from "./pages/users/UsersPage";
import UserEditPage from "./pages/users/UserEditPage";
import Otp from "./pages/auth/Otp";
import ProtectedRoute from "./core/components/ProtectedRoute";

import ForgotPassPage from "./pages/auth/ForgotPassPage";
import VerifyEmailPage from "./pages/auth/VerifyEmailPage";
import ResetPassPage from "./pages/auth/ResetPassPage";
import SetupProfile from "./pages/auth/SetupProfile";
import ExplorePage from "./pages/main/ExplorePage";
import NotificationPage from "./pages/main/NotificationPage";

function App() {
  history.navigate = useNavigate();
  history.location = useLocation();

  return (
    <>
      <Routes>
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/otp/:token" element={<Otp />} />
        <Route path="/setup-profile" element={<SetupProfile />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgotpass" element={<ForgotPassPage />} />
        <Route path="/verify/:token" element={<VerifyEmailPage />} />
        <Route path="/reset-password/:token" element={<ResetPassPage />} />

        <Route path="/" element={<ShellLayout />}>
          <Route path="" element={<LandingPage />} />
          <Route path="home" element={<LandingPage />} />
          <Route path="explore" element={<ExplorePage />} />
          <Route path="posts/:slug" element={<PostDetailPage />} />
          <Route path="notifications" element={<NotificationPage />} />
        </Route>

        <Route path="/profile" element={<ShellLayout />}>
          <Route element={<ProtectedRoute />}>
            <Route path="" element={<ProfilePage />} />
            <Route path="edit-profile" element={<EditProfilePage />} />
            <Route path="posts" element={<MyPostPage />} />
            <Route path="posts/edit/:id" element={<PostEditPage />} />
            <Route path="posts/new" element={<PostEditPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/edit/:id" element={<UserEditPage />} />
            <Route path="users/new" element={<UserEditPage />} />
          </Route>
        </Route>

        {/* <Route path="/posts" element={<ShellLayout />}>
          <Route path="" element={<PostPage />} />
          <Route path="search" element={<PostSearchPage />} />
          <Route path=":slug" element={<PostDetailPage />} />
        </Route> */}

       

        {/* <Route path="/studio" element={<ShellLayout />}>
          <Route element={<ProtectedRoute />}>
            <Route path="posts" element={<MyPostPage />} />
            <Route path="posts/edit/:id" element={<PostEditPage />} />
            <Route path="posts/new" element={<PostEditPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/edit/:id" element={<UserEditPage />} />
            <Route path="users/new" element={<UserEditPage />} />
          </Route>
        </Route> */}

        <Route
          path="*"
          element={
            <main style={{ padding: "1rem" }}>
              <p>There's nothing here!</p>
            </main>
          }
        />
      </Routes>
    </>
  );
}

export default App;
